export default "__VITE_ASSET__BlnI8iCq__"